import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';

import { ListbarComponent } from './listbar.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule
  ],
  declarations: [
    ListbarComponent
  ],
  exports: [
    ListbarComponent
  ],
  providers: [
  ]
})
export class ListbarModule { }
